function initShortDescCounter() {
  const selector = 'textarea[data-id=short-desc]';
  const shortDesc = jQuery(selector);

  if (shortDesc.length === 0) {
    return;
  }

  const textLength = shortDesc.val() ? (shortDesc.val() as string).length : 0;

  const html = `<div id="the-count">
    <span id="current">${textLength}</span>
    <span id="maximum">/ 270</span>
  </div>`;

  jQuery(html).insertAfter(selector);

  jQuery(document).on('keyup', selector, function () {
    const characterCount = (jQuery(this).val() as string).length;
    const current = jQuery('#current');
    current.text(characterCount);
  });
}

jQuery(document).ready(() => {
  const postType = jQuery('#post_type').val();

  if (postType === 'testimony') {
    setTimeout(initShortDescCounter, 1000);
  }
});
